import { VALIDATION_REG_EXP_EMAIL } from '@app/lib/Wizard/forgotPasswordValidationRegExps'

export const emailValidate = (email) => VALIDATION_REG_EXP_EMAIL.test(email)
